import { API_HELPER } from '@/helpers/api.js';
import { authHeader } from '@/helpers/auth-header.js';

const EXPERIENCES_API = 'Experiences';

export const experiencesService = {
  getList(input, language = null) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, EXPERIENCES_API]);
    const headers = { ...authHeader() };
    // If language is specified, use it; otherwise will use current locale from i18n
    if (language) {
      headers["Accept-Language"] = language;
    }
    const requestOptions = {
      method: 'GET',
      headers: headers
    };
    return API_HELPER.loggedApiCall(url, input, requestOptions);
  },
  
  getById(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, EXPERIENCES_API, id]);
    const requestOptions = {
      method: 'GET',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  create(data) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, EXPERIENCES_API]);
    const requestOptions = {
      method: 'POST',
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify(data)
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },

  getAvailabilities({ experienceId, date, pageSize = 100, pageNumber = 1 }) {
    const input = { pageSize, pageNumber, experienceId, date };
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, 'ExperienceAvailabilities']);
    const requestOptions = {
      method: 'GET',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, input, requestOptions);
  },
  
  update(data) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, EXPERIENCES_API]);
    const requestOptions = {
      method: 'PUT',
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify(data)
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  delete(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, EXPERIENCES_API, id]);
    const requestOptions = {
      method: 'DELETE',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  }
};

